import React from 'react';
import { GestureResponderEvent, Pressable } from 'react-native';
import { HubCardType } from '@/types';
import { LostItemSupportInfo } from '@/experiences/sales-portal/domain/insights/components/alert-card/alert-support-info/lost-item-support-info';
import { OverduePaymentSupportInfo } from '@/experiences/sales-portal/domain/insights/components/alert-card/alert-support-info/overdue-payment-support-info';
import type { Alert } from '@/experiences/sales-portal/domain/insights/blocs/types/alert';

interface AlertSupportInfoProps {
  alert: Alert;
  onPress?: () => void;
}

/** Renders the per-type support row of an alert card, or nothing for churn risk. */
export const AlertSupportInfo: React.FC<AlertSupportInfoProps> = ({
  alert,
  onPress,
}) => {
  const content = (() => {
    switch (alert.cardType) {
      case HubCardType.OverduePayment:
        return <OverduePaymentSupportInfo alert={alert} />;
      case HubCardType.LostItem:
        return <LostItemSupportInfo alert={alert} />;
      case HubCardType.ChurnRisk:
        return null;
    }
  })();

  if (!content) {
    return null;
  }

  return (
    <Pressable
      accessibilityRole="button"
      onPress={(event?: GestureResponderEvent) => {
        event?.stopPropagation();
        onPress?.();
      }}
    >
      {content}
    </Pressable>
  );
};
